import * as re from "react";
import Jr, { forwardRef as vr, useContext as It } from "react";
import { css as z } from "@emotion/react";
import { globalColor as H, illaPrefix as Z, applyBoxStyle as Kr, deleteCssProps as Hr } from "@illa-design/theme";
var cr = { exports: {} }, _e = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dr;
function Mt() {
  if (Dr)
    return _e;
  Dr = 1;
  var e = Jr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(c, p, h) {
    var d, y = {}, A = null, k = null;
    h !== void 0 && (A = "" + h), p.key !== void 0 && (A = "" + p.key), p.ref !== void 0 && (k = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (c && c.defaultProps)
      for (d in p = c.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: c, key: A, ref: k, props: y, _owner: o.current };
  }
  return _e.Fragment = n, _e.jsx = f, _e.jsxs = f, _e;
}
var xe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ir;
function Ft() {
  return Ir || (Ir = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Jr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), c = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), $ = Symbol.iterator, g = "@@iterator";
    function M(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = $ && t[$] || t[g];
      return typeof s == "function" ? s : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          l[m - 1] = arguments[m];
        P("error", t, l);
      }
    }
    function P(t, s, l) {
      {
        var m = x.ReactDebugCurrentFrame, S = m.getStackAddendum();
        S !== "" && (s += "%s", l = l.concat([S]));
        var N = l.map(function(_) {
          return String(_);
        });
        N.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, N);
      }
    }
    var D = !1, u = !1, V = !1, O = !1, He = !1, Pe;
    Pe = Symbol.for("react.module.reference");
    function Ze(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || He || t === o || t === h || t === d || O || t === k || D || u || V || typeof t == "object" && t !== null && (t.$$typeof === A || t.$$typeof === y || t.$$typeof === f || t.$$typeof === c || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Pe || t.getModuleId !== void 0));
    }
    function Xe(t, s, l) {
      var m = t.displayName;
      if (m)
        return m;
      var S = s.displayName || s.name || "";
      return S !== "" ? l + "(" + S + ")" : l;
    }
    function $e(t) {
      return t.displayName || "Context";
    }
    function G(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            var s = t;
            return $e(s) + ".Consumer";
          case f:
            var l = t;
            return $e(l._context) + ".Provider";
          case p:
            return Xe(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : G(t.type) || "Memo";
          case A: {
            var S = t, N = S._payload, _ = S._init;
            try {
              return G(_(N));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, te = 0, Ne, Ae, ve, ke, he, De, Ie;
    function Me() {
    }
    Me.__reactDisabledLog = !0;
    function Qe() {
      {
        if (te === 0) {
          Ne = console.log, Ae = console.info, ve = console.warn, ke = console.error, he = console.group, De = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Me,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function er() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, t, {
              value: Ne
            }),
            info: Q({}, t, {
              value: Ae
            }),
            warn: Q({}, t, {
              value: ve
            }),
            error: Q({}, t, {
              value: ke
            }),
            group: Q({}, t, {
              value: he
            }),
            groupCollapsed: Q({}, t, {
              value: De
            }),
            groupEnd: Q({}, t, {
              value: Ie
            })
          });
        }
        te < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var me = x.ReactCurrentDispatcher, ye;
    function ie(t, s, l) {
      {
        if (ye === void 0)
          try {
            throw Error();
          } catch (S) {
            var m = S.stack.trim().match(/\n( *(at )?)/);
            ye = m && m[1] || "";
          }
        return `
` + ye + t;
      }
    }
    var Ee = !1, se;
    {
      var rr = typeof WeakMap == "function" ? WeakMap : Map;
      se = new rr();
    }
    function v(t, s) {
      if (!t || Ee)
        return "";
      {
        var l = se.get(t);
        if (l !== void 0)
          return l;
      }
      var m;
      Ee = !0;
      var S = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var N;
      N = me.current, me.current = null, Qe();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (ee) {
              m = ee;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (ee) {
              m = ee;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            m = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && m && typeof ee.stack == "string") {
          for (var b = ee.stack.split(`
`), W = m.stack.split(`
`), I = b.length - 1, F = W.length - 1; I >= 1 && F >= 0 && b[I] !== W[F]; )
            F--;
          for (; I >= 1 && F >= 0; I--, F--)
            if (b[I] !== W[F]) {
              if (I !== 1 || F !== 1)
                do
                  if (I--, F--, F < 0 || b[I] !== W[F]) {
                    var q = `
` + b[I].replace(" at new ", " at ");
                    return t.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", t.displayName)), typeof t == "function" && se.set(t, q), q;
                  }
                while (I >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        Ee = !1, me.current = N, er(), Error.prepareStackTrace = S;
      }
      var ue = t ? t.displayName || t.name : "", kr = ue ? ie(ue) : "";
      return typeof t == "function" && se.set(t, kr), kr;
    }
    function be(t, s, l) {
      return v(t, !1);
    }
    function ce(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ne(t, s, l) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, ce(t));
      if (typeof t == "string")
        return ie(t);
      switch (t) {
        case h:
          return ie("Suspense");
        case d:
          return ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return be(t.render);
          case y:
            return ne(t.type, s, l);
          case A: {
            var m = t, S = m._payload, N = m._init;
            try {
              return ne(N(S), s, l);
            } catch {
            }
          }
        }
      return "";
    }
    var Fe = Object.prototype.hasOwnProperty, _r = {}, xr = x.ReactDebugCurrentFrame;
    function je(t) {
      if (t) {
        var s = t._owner, l = ne(t.type, t._source, s ? s.type : null);
        xr.setExtraStackFrame(l);
      } else
        xr.setExtraStackFrame(null);
    }
    function ht(t, s, l, m, S) {
      {
        var N = Function.call.bind(Fe);
        for (var _ in t)
          if (N(t, _)) {
            var b = void 0;
            try {
              if (typeof t[_] != "function") {
                var W = Error((m || "React class") + ": " + l + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              b = t[_](s, _, m, l, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (I) {
              b = I;
            }
            b && !(b instanceof Error) && (je(S), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", l, _, typeof b), je(null)), b instanceof Error && !(b.message in _r) && (_r[b.message] = !0, je(S), E("Failed %s type: %s", l, b.message), je(null));
          }
      }
    }
    var mt = Array.isArray;
    function tr(t) {
      return mt(t);
    }
    function yt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, l = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return l;
      }
    }
    function Et(t) {
      try {
        return Sr(t), !1;
      } catch {
        return !0;
      }
    }
    function Sr(t) {
      return "" + t;
    }
    function Rr(t) {
      if (Et(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", yt(t)), Sr(t);
    }
    var ge = x.ReactCurrentOwner, bt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, wr, Cr, nr;
    nr = {};
    function gt(t) {
      if (Fe.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function _t(t) {
      if (Fe.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function xt(t, s) {
      if (typeof t.ref == "string" && ge.current && s && ge.current.stateNode !== s) {
        var l = G(ge.current.type);
        nr[l] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(ge.current.type), t.ref), nr[l] = !0);
      }
    }
    function St(t, s) {
      {
        var l = function() {
          wr || (wr = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        l.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: l,
          configurable: !0
        });
      }
    }
    function Rt(t, s) {
      {
        var l = function() {
          Cr || (Cr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        l.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: l,
          configurable: !0
        });
      }
    }
    var wt = function(t, s, l, m, S, N, _) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: l,
        props: _,
        // Record the component responsible for creating this element.
        _owner: N
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: S
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function Ct(t, s, l, m, S) {
      {
        var N, _ = {}, b = null, W = null;
        l !== void 0 && (Rr(l), b = "" + l), _t(s) && (Rr(s.key), b = "" + s.key), gt(s) && (W = s.ref, xt(s, S));
        for (N in s)
          Fe.call(s, N) && !bt.hasOwnProperty(N) && (_[N] = s[N]);
        if (t && t.defaultProps) {
          var I = t.defaultProps;
          for (N in I)
            _[N] === void 0 && (_[N] = I[N]);
        }
        if (b || W) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          b && St(_, F), W && Rt(_, F);
        }
        return wt(t, b, W, S, m, ge.current, _);
      }
    }
    var ar = x.ReactCurrentOwner, Tr = x.ReactDebugCurrentFrame;
    function fe(t) {
      if (t) {
        var s = t._owner, l = ne(t.type, t._source, s ? s.type : null);
        Tr.setExtraStackFrame(l);
      } else
        Tr.setExtraStackFrame(null);
    }
    var or;
    or = !1;
    function ir(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Or() {
      {
        if (ar.current) {
          var t = G(ar.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Tt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), l = t.lineNumber;
          return `

Check your code at ` + s + ":" + l + ".";
        }
        return "";
      }
    }
    var Pr = {};
    function Ot(t) {
      {
        var s = Or();
        if (!s) {
          var l = typeof t == "string" ? t : t.displayName || t.name;
          l && (s = `

Check the top-level render call using <` + l + ">.");
        }
        return s;
      }
    }
    function $r(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var l = Ot(s);
        if (Pr[l])
          return;
        Pr[l] = !0;
        var m = "";
        t && t._owner && t._owner !== ar.current && (m = " It was passed a child from " + G(t._owner.type) + "."), fe(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', l, m), fe(null);
      }
    }
    function Nr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (tr(t))
          for (var l = 0; l < t.length; l++) {
            var m = t[l];
            ir(m) && $r(m, s);
          }
        else if (ir(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var S = M(t);
          if (typeof S == "function" && S !== t.entries)
            for (var N = S.call(t), _; !(_ = N.next()).done; )
              ir(_.value) && $r(_.value, s);
        }
      }
    }
    function Pt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var l;
        if (typeof s == "function")
          l = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          l = s.propTypes;
        else
          return;
        if (l) {
          var m = G(s);
          ht(l, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !or) {
          or = !0;
          var S = G(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", S || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function $t(t) {
      {
        for (var s = Object.keys(t.props), l = 0; l < s.length; l++) {
          var m = s[l];
          if (m !== "children" && m !== "key") {
            fe(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), fe(null);
            break;
          }
        }
        t.ref !== null && (fe(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), fe(null));
      }
    }
    function Ar(t, s, l, m, S, N) {
      {
        var _ = Ze(t);
        if (!_) {
          var b = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = Tt(S);
          W ? b += W : b += Or();
          var I;
          t === null ? I = "null" : tr(t) ? I = "array" : t !== void 0 && t.$$typeof === r ? (I = "<" + (G(t.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, b);
        }
        var F = Ct(t, s, l, S, N);
        if (F == null)
          return F;
        if (_) {
          var q = s.children;
          if (q !== void 0)
            if (m)
              if (tr(q)) {
                for (var ue = 0; ue < q.length; ue++)
                  Nr(q[ue], t);
                Object.freeze && Object.freeze(q);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nr(q, t);
        }
        return t === a ? $t(F) : Pt(F), F;
      }
    }
    function Nt(t, s, l) {
      return Ar(t, s, l, !0);
    }
    function At(t, s, l) {
      return Ar(t, s, l, !1);
    }
    var kt = At, Dt = Nt;
    xe.Fragment = a, xe.jsx = kt, xe.jsxs = Dt;
  }()), xe;
}
process.env.NODE_ENV === "production" ? cr.exports = Mt() : cr.exports = Ft();
var ze = cr.exports;
function jt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Vt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Yt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Vt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var f = jt(o);
      try {
        f.insertRule(a, f.cssRules.length);
      } catch (c) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', c);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), L = "-ms-", Ue = "-moz-", R = "-webkit-", hr = "comm", mr = "rule", yr = "decl", Lt = "@import", Zr = "@keyframes", Wt = "@layer", zt = Math.abs, qe = String.fromCharCode, Ut = Object.assign;
function Bt(e, r) {
  return Y(e, 0) ^ 45 ? (((r << 2 ^ Y(e, 0)) << 2 ^ Y(e, 1)) << 2 ^ Y(e, 2)) << 2 ^ Y(e, 3) : 0;
}
function Xr(e) {
  return e.trim();
}
function qt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function w(e, r, n) {
  return e.replace(r, n);
}
function fr(e, r) {
  return e.indexOf(r);
}
function Y(e, r) {
  return e.charCodeAt(r) | 0;
}
function we(e, r, n) {
  return e.slice(r, n);
}
function K(e) {
  return e.length;
}
function Er(e) {
  return e.length;
}
function Ve(e, r) {
  return r.push(e), e;
}
function Gt(e, r) {
  return e.map(r).join("");
}
var Ge = 1, de = 1, Qr = 0, U = 0, j = 0, pe = "";
function Je(e, r, n, a, o, i, f) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: Ge, column: de, length: f, return: "" };
}
function Se(e, r) {
  return Ut(Je("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Jt() {
  return j;
}
function Kt() {
  return j = U > 0 ? Y(pe, --U) : 0, de--, j === 10 && (de = 1, Ge--), j;
}
function B() {
  return j = U < Qr ? Y(pe, U++) : 0, de++, j === 10 && (de = 1, Ge++), j;
}
function X() {
  return Y(pe, U);
}
function Ye() {
  return U;
}
function Oe(e, r) {
  return we(pe, e, r);
}
function Ce(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function et(e) {
  return Ge = de = 1, Qr = K(pe = e), U = 0, [];
}
function rt(e) {
  return pe = "", e;
}
function Le(e) {
  return Xr(Oe(U - 1, ur(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Ht(e) {
  for (; (j = X()) && j < 33; )
    B();
  return Ce(e) > 2 || Ce(j) > 3 ? "" : " ";
}
function Zt(e, r) {
  for (; --r && B() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return Oe(e, Ye() + (r < 6 && X() == 32 && B() == 32));
}
function ur(e) {
  for (; B(); )
    switch (j) {
      case e:
        return U;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ur(j);
        break;
      case 40:
        e === 41 && ur(e);
        break;
      case 92:
        B();
        break;
    }
  return U;
}
function Xt(e, r) {
  for (; B() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && X() === 47)
      break;
  return "/*" + Oe(r, U - 1) + "*" + qe(e === 47 ? e : B());
}
function Qt(e) {
  for (; !Ce(X()); )
    B();
  return Oe(e, U);
}
function en(e) {
  return rt(We("", null, null, null, [""], e = et(e), 0, [0], e));
}
function We(e, r, n, a, o, i, f, c, p) {
  for (var h = 0, d = 0, y = f, A = 0, k = 0, $ = 0, g = 1, M = 1, x = 1, E = 0, P = "", D = o, u = i, V = a, O = P; M; )
    switch ($ = E, E = B()) {
      case 40:
        if ($ != 108 && Y(O, y - 1) == 58) {
          fr(O += w(Le(E), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += Le(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += Ht($);
        break;
      case 92:
        O += Zt(Ye() - 1, 7);
        continue;
      case 47:
        switch (X()) {
          case 42:
          case 47:
            Ve(rn(Xt(B(), Ye()), r, n), p);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * g:
        c[h++] = K(O) * x;
      case 125 * g:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            M = 0;
          case 59 + d:
            x == -1 && (O = w(O, /\f/g, "")), k > 0 && K(O) - y && Ve(k > 32 ? Fr(O + ";", a, n, y - 1) : Fr(w(O, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            O += ";";
          default:
            if (Ve(V = Mr(O, r, n, h, d, o, c, P, D = [], u = [], y), i), E === 123)
              if (d === 0)
                We(O, r, V, V, D, i, y, c, u);
              else
                switch (A === 99 && Y(O, 3) === 110 ? 100 : A) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    We(e, V, V, a && Ve(Mr(e, V, V, 0, 0, o, c, P, o, D = [], y), u), o, u, y, c, a ? D : u);
                    break;
                  default:
                    We(O, V, V, V, [""], u, 0, c, u);
                }
        }
        h = d = k = 0, g = x = 1, P = O = "", y = f;
        break;
      case 58:
        y = 1 + K(O), k = $;
      default:
        if (g < 1) {
          if (E == 123)
            --g;
          else if (E == 125 && g++ == 0 && Kt() == 125)
            continue;
        }
        switch (O += qe(E), E * g) {
          case 38:
            x = d > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            c[h++] = (K(O) - 1) * x, x = 1;
            break;
          case 64:
            X() === 45 && (O += Le(B())), A = X(), d = y = K(P = O += Qt(Ye())), E++;
            break;
          case 45:
            $ === 45 && K(O) == 2 && (g = 0);
        }
    }
  return i;
}
function Mr(e, r, n, a, o, i, f, c, p, h, d) {
  for (var y = o - 1, A = o === 0 ? i : [""], k = Er(A), $ = 0, g = 0, M = 0; $ < a; ++$)
    for (var x = 0, E = we(e, y + 1, y = zt(g = f[$])), P = e; x < k; ++x)
      (P = Xr(g > 0 ? A[x] + " " + E : w(E, /&\f/g, A[x]))) && (p[M++] = P);
  return Je(e, r, n, o === 0 ? mr : c, p, h, d);
}
function rn(e, r, n) {
  return Je(e, r, n, hr, qe(Jt()), we(e, 2, -2), 0);
}
function Fr(e, r, n, a) {
  return Je(e, r, n, yr, we(e, 0, a), we(e, a + 1, -1), a);
}
function le(e, r) {
  for (var n = "", a = Er(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function tn(e, r, n, a) {
  switch (e.type) {
    case Wt:
      if (e.children.length)
        break;
    case Lt:
    case yr:
      return e.return = e.return || e.value;
    case hr:
      return "";
    case Zr:
      return e.return = e.value + "{" + le(e.children, a) + "}";
    case mr:
      e.value = e.props.join(",");
  }
  return K(n = le(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function nn(e) {
  var r = Er(e);
  return function(n, a, o, i) {
    for (var f = "", c = 0; c < r; c++)
      f += e[c](n, a, o, i) || "";
    return f;
  };
}
function an(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function on(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var sn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = X(), o === 38 && i === 12 && (n[a] = 1), !Ce(i); )
    B();
  return Oe(r, U);
}, cn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (Ce(o)) {
      case 0:
        o === 38 && X() === 12 && (n[a] = 1), r[a] += sn(U - 1, n, a);
        break;
      case 2:
        r[a] += Le(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = X() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += qe(o);
    }
  while (o = B());
  return r;
}, fn = function(r, n) {
  return rt(cn(et(r), n));
}, jr = /* @__PURE__ */ new WeakMap(), un = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !jr.get(a)) && !o) {
      jr.set(r, !0);
      for (var i = [], f = fn(n, i), c = a.props, p = 0, h = 0; p < f.length; p++)
        for (var d = 0; d < c.length; d++, h++)
          r.props[h] = i[p] ? f[p].replace(/&\f/g, c[d]) : c[d] + " " + f[p];
    }
  }
}, ln = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, dn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", pn = function(r) {
  return r.type === "comm" && r.children.indexOf(dn) > -1;
}, vn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var f = !!n.parent, c = f ? n.parent.children : (
          // global rule at the root level
          o
        ), p = c.length - 1; p >= 0; p--) {
          var h = c[p];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (pn(h))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, tt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, hn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!tt(n[a]))
      return !0;
  return !1;
}, Vr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, mn = function(r, n, a) {
  tt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Vr(r)) : hn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Vr(r)));
};
function nt(e, r) {
  switch (Bt(e, r)) {
    case 5103:
      return R + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return R + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return R + e + Ue + e + L + e + e;
    case 6828:
    case 4268:
      return R + e + L + e + e;
    case 6165:
      return R + e + L + "flex-" + e + e;
    case 5187:
      return R + e + w(e, /(\w+).+(:[^]+)/, R + "box-$1$2" + L + "flex-$1$2") + e;
    case 5443:
      return R + e + L + "flex-item-" + w(e, /flex-|-self/, "") + e;
    case 4675:
      return R + e + L + "flex-line-pack" + w(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return R + e + L + w(e, "shrink", "negative") + e;
    case 5292:
      return R + e + L + w(e, "basis", "preferred-size") + e;
    case 6060:
      return R + "box-" + w(e, "-grow", "") + R + e + L + w(e, "grow", "positive") + e;
    case 4554:
      return R + w(e, /([^-])(transform)/g, "$1" + R + "$2") + e;
    case 6187:
      return w(w(w(e, /(zoom-|grab)/, R + "$1"), /(image-set)/, R + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return w(e, /(image-set\([^]*)/, R + "$1$`$1");
    case 4968:
      return w(w(e, /(.+:)(flex-)?(.*)/, R + "box-pack:$3" + L + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + R + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return w(e, /(.+)-inline(.+)/, R + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (K(e) - 1 - r > 6)
        switch (Y(e, r + 1)) {
          case 109:
            if (Y(e, r + 4) !== 45)
              break;
          case 102:
            return w(e, /(.+:)(.+)-([^]+)/, "$1" + R + "$2-$3$1" + Ue + (Y(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~fr(e, "stretch") ? nt(w(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (Y(e, r + 1) !== 115)
        break;
    case 6444:
      switch (Y(e, K(e) - 3 - (~fr(e, "!important") && 10))) {
        case 107:
          return w(e, ":", ":" + R) + e;
        case 101:
          return w(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + R + (Y(e, 14) === 45 ? "inline-" : "") + "box$3$1" + R + "$2$3$1" + L + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Y(e, r + 11)) {
        case 114:
          return R + e + L + w(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return R + e + L + w(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return R + e + L + w(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return R + e + L + e + e;
  }
  return e;
}
var yn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case yr:
        r.return = nt(r.value, r.length);
        break;
      case Zr:
        return le([Se(r, {
          value: w(r.value, "@", "@" + R)
        })], o);
      case mr:
        if (r.length)
          return Gt(r.props, function(i) {
            switch (qt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return le([Se(r, {
                  props: [w(i, /:(read-\w+)/, ":" + Ue + "$1")]
                })], o);
              case "::placeholder":
                return le([Se(r, {
                  props: [w(i, /:(plac\w+)/, ":" + R + "input-$1")]
                }), Se(r, {
                  props: [w(i, /:(plac\w+)/, ":" + Ue + "$1")]
                }), Se(r, {
                  props: [w(i, /:(plac\w+)/, L + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, En = [yn], bn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(g) {
      var M = g.getAttribute("data-emotion");
      M.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || En;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, f, c = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var M = g.getAttribute("data-emotion").split(" "), x = 1; x < M.length; x++)
        i[M[x]] = !0;
      c.push(g);
    }
  );
  var p, h = [un, ln];
  process.env.NODE_ENV !== "production" && h.push(vn({
    get compat() {
      return $.compat;
    }
  }), mn);
  {
    var d, y = [tn, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? d.insert(g.return) : g.value && g.type !== hr && d.insert(g.value + "{}"));
    } : an(function(g) {
      d.insert(g);
    })], A = nn(h.concat(o, y)), k = function(M) {
      return le(en(M), A);
    };
    p = function(M, x, E, P) {
      d = E, process.env.NODE_ENV !== "production" && x.map !== void 0 && (d = {
        insert: function(u) {
          E.insert(u + x.map);
        }
      }), k(M ? M + "{" + x.styles + "}" : x.styles), P && ($.inserted[x.name] = !0);
    };
  }
  var $ = {
    key: n,
    sheet: new Yt({
      key: n,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return $.sheet.hydrate(c), $;
}, lr = { exports: {} }, C = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yr;
function gn() {
  if (Yr)
    return C;
  Yr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function P(u) {
    if (typeof u == "object" && u !== null) {
      var V = u.$$typeof;
      switch (V) {
        case r:
          switch (u = u.type, u) {
            case p:
            case h:
            case a:
            case i:
            case o:
            case y:
              return u;
            default:
              switch (u = u && u.$$typeof, u) {
                case c:
                case d:
                case $:
                case k:
                case f:
                  return u;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function D(u) {
    return P(u) === h;
  }
  return C.AsyncMode = p, C.ConcurrentMode = h, C.ContextConsumer = c, C.ContextProvider = f, C.Element = r, C.ForwardRef = d, C.Fragment = a, C.Lazy = $, C.Memo = k, C.Portal = n, C.Profiler = i, C.StrictMode = o, C.Suspense = y, C.isAsyncMode = function(u) {
    return D(u) || P(u) === p;
  }, C.isConcurrentMode = D, C.isContextConsumer = function(u) {
    return P(u) === c;
  }, C.isContextProvider = function(u) {
    return P(u) === f;
  }, C.isElement = function(u) {
    return typeof u == "object" && u !== null && u.$$typeof === r;
  }, C.isForwardRef = function(u) {
    return P(u) === d;
  }, C.isFragment = function(u) {
    return P(u) === a;
  }, C.isLazy = function(u) {
    return P(u) === $;
  }, C.isMemo = function(u) {
    return P(u) === k;
  }, C.isPortal = function(u) {
    return P(u) === n;
  }, C.isProfiler = function(u) {
    return P(u) === i;
  }, C.isStrictMode = function(u) {
    return P(u) === o;
  }, C.isSuspense = function(u) {
    return P(u) === y;
  }, C.isValidElementType = function(u) {
    return typeof u == "string" || typeof u == "function" || u === a || u === h || u === i || u === o || u === y || u === A || typeof u == "object" && u !== null && (u.$$typeof === $ || u.$$typeof === k || u.$$typeof === f || u.$$typeof === c || u.$$typeof === d || u.$$typeof === M || u.$$typeof === x || u.$$typeof === E || u.$$typeof === g);
  }, C.typeOf = P, C;
}
var T = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lr;
function _n() {
  return Lr || (Lr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function P(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === y || v === A || typeof v == "object" && v !== null && (v.$$typeof === $ || v.$$typeof === k || v.$$typeof === f || v.$$typeof === c || v.$$typeof === d || v.$$typeof === M || v.$$typeof === x || v.$$typeof === E || v.$$typeof === g);
    }
    function D(v) {
      if (typeof v == "object" && v !== null) {
        var be = v.$$typeof;
        switch (be) {
          case r:
            var ce = v.type;
            switch (ce) {
              case p:
              case h:
              case a:
              case i:
              case o:
              case y:
                return ce;
              default:
                var ne = ce && ce.$$typeof;
                switch (ne) {
                  case c:
                  case d:
                  case $:
                  case k:
                  case f:
                    return ne;
                  default:
                    return be;
                }
            }
          case n:
            return be;
        }
      }
    }
    var u = p, V = h, O = c, He = f, Pe = r, Ze = d, Xe = a, $e = $, G = k, Q = n, te = i, Ne = o, Ae = y, ve = !1;
    function ke(v) {
      return ve || (ve = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), he(v) || D(v) === p;
    }
    function he(v) {
      return D(v) === h;
    }
    function De(v) {
      return D(v) === c;
    }
    function Ie(v) {
      return D(v) === f;
    }
    function Me(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Qe(v) {
      return D(v) === d;
    }
    function er(v) {
      return D(v) === a;
    }
    function me(v) {
      return D(v) === $;
    }
    function ye(v) {
      return D(v) === k;
    }
    function ie(v) {
      return D(v) === n;
    }
    function Ee(v) {
      return D(v) === i;
    }
    function se(v) {
      return D(v) === o;
    }
    function rr(v) {
      return D(v) === y;
    }
    T.AsyncMode = u, T.ConcurrentMode = V, T.ContextConsumer = O, T.ContextProvider = He, T.Element = Pe, T.ForwardRef = Ze, T.Fragment = Xe, T.Lazy = $e, T.Memo = G, T.Portal = Q, T.Profiler = te, T.StrictMode = Ne, T.Suspense = Ae, T.isAsyncMode = ke, T.isConcurrentMode = he, T.isContextConsumer = De, T.isContextProvider = Ie, T.isElement = Me, T.isForwardRef = Qe, T.isFragment = er, T.isLazy = me, T.isMemo = ye, T.isPortal = ie, T.isProfiler = Ee, T.isStrictMode = se, T.isSuspense = rr, T.isValidElementType = P, T.typeOf = D;
  }()), T;
}
process.env.NODE_ENV === "production" ? lr.exports = gn() : lr.exports = _n();
var xn = lr.exports, at = xn, Sn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Rn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ot = {};
ot[at.ForwardRef] = Sn;
ot[at.Memo] = Rn;
var wn = !0;
function Cn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var it = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  wn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, Tn = function(r, n, a) {
  it(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function On(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Pn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Wr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, $n = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Nn = /[A-Z]|^ms/g, st = /_EMO_([^_]+?)_([^]*?)_EMO_/g, br = function(r) {
  return r.charCodeAt(1) === 45;
}, zr = function(r) {
  return r != null && typeof r != "boolean";
}, sr = /* @__PURE__ */ on(function(e) {
  return br(e) ? e : e.replace(Nn, "-$&").toLowerCase();
}), Be = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(st, function(a, o, i) {
          return J = {
            name: o,
            styles: i,
            next: J
          }, o;
        });
  }
  return Pn[r] !== 1 && !br(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var An = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, kn = ["normal", "none", "initial", "inherit", "unset"], Dn = Be, In = /^-ms-/, Mn = /-(.)/g, Ur = {};
  Be = function(r, n) {
    if (r === "content" && (typeof n != "string" || kn.indexOf(n) === -1 && !An.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Dn(r, n);
    return a !== "" && !br(r) && r.indexOf("-") !== -1 && Ur[r] === void 0 && (Ur[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(In, "ms-").replace(Mn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var ct = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Te(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ct);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return J = {
          name: n.name,
          styles: n.styles,
          next: J
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            J = {
              name: a.name,
              styles: a.styles,
              next: J
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Fn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = J, f = n(e);
        return J = i, Te(e, r, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var c = [], p = n.replace(st, function(d, y, A) {
          var k = "animation" + c.length;
          return c.push("const " + k + " = keyframes`" + A.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + k + "}";
        });
        c.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(c, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function Fn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Te(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var f = n[i];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? a += i + "{" + r[f] + "}" : zr(f) && (a += sr(i) + ":" + Be(i, f) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ct);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var c = 0; c < f.length; c++)
            zr(f[c]) && (a += sr(i) + ":" + Be(i, f[c]) + ";");
        else {
          var p = Te(e, r, f);
          switch (i) {
            case "animation":
            case "animationName": {
              a += sr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error($n), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Br = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ft;
process.env.NODE_ENV !== "production" && (ft = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var J, qr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  J = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (o = !1, i += Te(a, n, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(Wr), i += f[0]);
  for (var c = 1; c < r.length; c++)
    i += Te(a, n, r[c]), o && (process.env.NODE_ENV !== "production" && f[c] === void 0 && console.error(Wr), i += f[c]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(ft, function(A) {
    return p = A, "";
  })), Br.lastIndex = 0;
  for (var h = "", d; (d = Br.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = On(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: J,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: J
  };
}, jn = function(r) {
  return r();
}, Vn = re["useInsertionEffect"] ? re["useInsertionEffect"] : !1, Yn = Vn || jn, Ke = {}.hasOwnProperty, gr = /* @__PURE__ */ re.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ bn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (gr.displayName = "EmotionCacheContext");
gr.Provider;
var Ln = function(r) {
  return /* @__PURE__ */ vr(function(n, a) {
    var o = It(gr);
    return r(n, o, a);
  });
}, ut = /* @__PURE__ */ re.createContext({});
process.env.NODE_ENV !== "production" && (ut.displayName = "EmotionThemeContext");
var Gr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Wn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Gr(n[1]);
}, zn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Un = function(r) {
  return r.replace(/\$/g, "-");
}, Bn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Wn(n[a]);
      if (o) {
        if (zn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Un(o);
      }
    }
}, dr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", pr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", lt = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Ke.call(n, o) && (a[o] = n[o]);
  if (a[dr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Bn(new Error().stack);
    i && (a[pr] = i);
  }
  return a;
}, qn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return it(n, a, o), Yn(function() {
    return Tn(n, a, o);
  }), null;
}, dt = /* @__PURE__ */ Ln(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[dr], i = [a], f = "";
  typeof e.className == "string" ? f = Cn(r.registered, i, e.className) : e.className != null && (f = e.className + " ");
  var c = qr(i, void 0, re.useContext(ut));
  if (process.env.NODE_ENV !== "production" && c.name.indexOf("-") === -1) {
    var p = e[pr];
    p && (c = qr([c, "label:" + p + ";"]));
  }
  f += r.key + "-" + c.name;
  var h = {};
  for (var d in e)
    Ke.call(e, d) && d !== "css" && d !== dr && (process.env.NODE_ENV === "production" || d !== pr) && (h[d] = e[d]);
  return h.ref = n, h.className = f, /* @__PURE__ */ re.createElement(re.Fragment, null, /* @__PURE__ */ re.createElement(qn, {
    cache: r,
    serialized: c,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ re.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (dt.displayName = "EmotionCssPropInternal");
var pt = dt;
function Re(e, r, n) {
  return Ke.call(r, "css") ? ze.jsx(pt, lt(e, r), n) : ze.jsx(e, r, n);
}
function Gn(e, r, n) {
  return Ke.call(r, "css") ? ze.jsxs(pt, lt(e, r), n) : ze.jsxs(e, r, n);
}
function ae(e, r, n, a) {
  let o = z``;
  n != null && (o = z`
      flex-basis: ${n};
    `);
  let i = z``;
  a != null && (i = z`
      flex-grow: ${a};
    `);
  const f = H(`--${Z}-${e}-08`) === "" ? H(`--${Z}-${e}-03`) === "" ? e : H(`--${Z}-${e}-03`) : H(`--${Z}-${e}-08`);
  return z`
    vertical-align: middle;
    border-style: ${r};
    border-width: 0 0 ${r == "double" ? "3px" : "1px"} 0;
    border-color: ${f};
    width: 100%;
    ${o};
    ${i};
  `;
}
function oe(e, r, n, a) {
  let o = z``;
  n != null && (o = z`
      flex-basis: ${n};
    `);
  let i = z``;
  a != null && (i = z`
      flex-grow: ${a};
    `);
  const f = H(`--${Z}-${e}-08`) === "" ? H(`--${Z}-${e}-03`) === "" ? e : H(`--${Z}-${e}-03`) : H(`--${Z}-${e}-08`);
  return z`
    display: inline-flex;
    vertical-align: middle;
    border-width: 0 0 0 ${r == "double" ? "3px" : "1px"};
    border-color: ${f};
    border-style: ${r};
    height: 1em;
    flex-basis: ${n};
    ${o};
    ${i};
  `;
}
function Jn(e) {
  return e == "horizontal" ? z`
      align-items: center;
      display: flex;
      flex-direction: row;
    ` : z`
      align-items: center;
      display: flex;
      flex-direction: column;
    `;
}
function Kn(e, r) {
  const n = H(`--${Z}-${e}-02`) === "" ? e : H(`--${Z}-${e}-02`);
  return z`
    color: ${n};
    margin-left: 16px;
    margin-right: 16px;
    font-size: ${r};
  `;
}
const vt = vr((e, r) => {
  const { variant: n = "solid", text: a, fs: o = "14px", direction: i = "horizontal", textAlign: f = "center", colorScheme: c = "grayBlue", ...p } = e;
  let h = z``, d = z``;
  switch (i) {
    case "vertical":
      switch (f) {
        case "start":
          h = oe(c, n, "20%"), d = oe(c, n, void 0, 1);
          break;
        case "center":
          h = oe(c, n), d = oe(c, n);
          break;
        case "end":
          h = oe(c, n, void 0, 1), d = oe(c, n, "20%");
          break;
      }
      break;
    case "horizontal":
      switch (f) {
        case "start":
          h = ae(c, n, "20%"), d = ae(c, n, void 0, 1);
          break;
        case "center":
          h = ae(c, n), d = ae(c, n);
          break;
        case "end":
          h = ae(c, n, void 0, 1), d = ae(c, n, "20%");
          break;
      }
      break;
  }
  return Gn("div", { css: [
    Jn(i),
    Kr(e)
  ], ref: r, ...Hr(p), children: [Re("div", { css: h }), Re("span", { css: Kn(c, o), children: a }), Re("div", { css: d })] });
});
vt.displayName = "DividerWithText";
const Hn = vr((e, r) => {
  const { direction: n = "horizontal", variant: a = "solid", text: o, textAlign: i, colorScheme: f = "grayBlue", ...c } = e;
  let p;
  switch (n) {
    case "vertical":
      p = oe(f, a, "center");
      break;
    case "horizontal":
      p = ae(f, a, "center");
      break;
  }
  return o && (o == null ? void 0 : o.length) > 0 ? Re(vt, { ref: r, ...e }) : Re("div", { css: [p, Kr(e)], ref: r, ...Hr(c) });
});
Hn.displayName = "Divider";
export {
  Hn as Divider
};
//# sourceMappingURL=index.js.map
